import React from 'react'

import food from 'assets/icons/menu/food.svg'
import marketplace from 'assets/icons/menu/marketplace.svg'
import merchandise from 'assets/icons/menu/merchandise.svg'

import { createLegacyCanopyLink } from 'utils/links'
import getCanopySpas from 'utils/getCanopySpas'

import data from 'spas'
import MenuCard from 'components/MenuCard'

const MainMenu = () => {
  const staticMenuItems = [
    {
      display_name: 'F&B',
      description: 'New version coming soon. Manage F&B orders and menus configurations',
      icon: food,
      color: '#17a141',
      isOpenInNew: true,
      link: createLegacyCanopyLink('orders/food'),
    },
    {
      display_name: 'Merchandise',
      description: 'New version coming soon. Manage merch orders and menu configurations',
      icon: merchandise,
      color: '#2253ff',
      isOpenInNew: true,
      link: createLegacyCanopyLink('orders/merchandise'),
    },
    {
      display_name: 'Marketplace',
      description: 'New version coming soon. Manage marketplace orders and sales configurations',
      icon: marketplace,
      color: '#e21e5c',
      isOpenInNew: true,
      link: createLegacyCanopyLink('global_items'),
    },
  ]

  const menuItems = [...getCanopySpas(data), ...staticMenuItems]

  return (
    <section className="main-menu">
      {menuItems.map(item => (
        <MenuCard
          color={item.color}
          description={item.description}
          displayName={item.display_name}
          icon={item.icon}
          isOpenInNew={item.isOpenInNew}
          key={item.title}
          url={item.link}
        />
      ))}
    </section>
  )
}

export default MainMenu
